import { useState } from 'react'
import CalenderView from './CalenderView'
import ListView from './ListView'

const ScheduleList = ({className}) => {
 
  const [calenderView, setCalenderView] = useState(true)

  if (calenderView){
    return <CalenderView className={className} close={() => setCalenderView(false)} />
  }
  return (
    <ListView className={className} close={() => setCalenderView(true)}/>
  )
}

export default ScheduleList
